module.exports = __webpack_public_path__ + "static/media/check.e92eb194.svg";